<template>
  <basic-container>
    <!-- <el-switch v-model="allAndManage" :inactive-value="1" :active-value="0" active-text="所有用户" inactive-text="健管师" @change="handleAllAndManageChange"></el-switch> -->

    <div class="path-container" style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px; margin-top: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>健康管理工作站</el-breadcrumb-item>
        <el-breadcrumb-item>线上健康管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div>
      <audio ref="audioElement" src="https://health-planet.oss-cn-shanghai.aliyuncs.com/1754625932005_remind1.mp3"></audio>
    </div>

    <div style="display: flex; justify-content: flex-end; margin-bottom: 10px; margin-right: 20px">
      <el-button v-show="notData === 1" @click="notDataClick(1)" :type="notData === 1 ? 'primary' : ''">三天数据未上传</el-button>
      <el-button v-show="notWeekReport === 1" @click="notDataClick(2)" :type="notWeekReport === 1 ? 'primary' : ''">周状态未查看</el-button>
      <el-button v-show="notBehavioralIntervention === 1" @click="notDataClick(3)" :type="notBehavioralIntervention === 1 ? 'primary' : ''">行为干预未完成</el-button>
      <el-button v-show="notHealthScheme === 1" @click="notDataClick(4)" :type="notHealthScheme === 1 ? 'primary' : ''">健康档案未生成用户</el-button>
      <el-button v-show="notHealthReportAndQuestion === 1" @click="notDataClick(5)" :type="notHealthReportAndQuestion === 1 ? 'primary' : ''">健康档案未完成</el-button>
      <!-- <el-button type="success" @click="toCreateReportUser">新建报告解读用户</el-button> -->
    </div>
    <avue-crud
      :option="channel === '大白主动健康' ? option : option2"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="(page) => onLoad(page, params)"
      @cell-click="handleCellClick"
    >
      <!-- :header-cell-class-name="headerCellClassName" -->
      <template slot="menuLeft"></template>
      <template slot-scope="scope" slot="menu1">
        <el-button type="text" size="small" @click="archiveType1(scope.row)">查看数据</el-button>
      </template>
      <template slot-scope="scope" slot="menu2">
        <el-button type="text" size="small" @click="archiveType2(scope.row)">查看完善进度</el-button>
      </template>
      <template slot-scope="scope" slot="menu3">
        <el-button type="text" size="small" @click="archiveType3(scope.row)">查看已生成方案</el-button>
      </template>
      <template slot-scope="scope" slot="menu4">
        <el-button type="text" size="small" @click="archiveType4(scope.row)">
          <!-- 治疗中 -->
          {{ scope.row.punch == 1 ? "治疗中" : "未治疗" }}
        </el-button>
      </template>
      <template slot-scope="scope" slot="push">
        <el-button type="text" size="small" @click="archiveType5(scope.row)">
          {{ scope.row.push == 1 ? "已开通" : "未开通" }}
        </el-button>
      </template>
      <template slot-scope="scope" slot="consult">
        <el-button type="text" size="small" @click="toHealthConsult(scope.row)" :style="{ color: scope.row.consult == 1 ? '#409EFF' : 'black' }">
          {{ scope.row.consult == 0 && scope.row.healthManager == undefined ? "--" : scope.row.consult == 1 ? "新消息" : "咨询查询" }}
        </el-button>
      </template>
      <template slot-scope="scope" slot="AIConsult">
        <el-button type="text" size="small" @click="toAIHealthConsult(scope.row)">前往咨询</el-button>
      </template>
      <template slot-scope="scope" slot="healthManager">
        <el-button type="text" size="small" @click="toShowHealthManager(scope.row)" style="color: black">
          {{ scope.row.healthManager || "--" }}
        </el-button>
      </template>

      <template slot="menu" slot-scope="{ row, index }">
        <el-button type="text" size="small" @click="weekReport(row, index)">周报文本</el-button>
        <!-- <el-button type="text" size="small" @click="toCopy(row, index)">复制</el-button> -->
        <el-button type="text" size="small" @click="toPush(row, index)">推送</el-button>
      </template>

      <template slot-scope="scope" slot="aiWeekReport">
        <el-button type="text" size="small" @click="toGenerateAiWeekReportByUser(scope.row)">{{ scope.row.aiWeekReport || "生成报告" }}</el-button>
      </template>

      <template slot-scope="scope" slot="aiWeekReportByReport">
        <el-button type="text" size="small" @click="toGenerateAiWeekReportByUser(scope.row)">{{ scope.row.aiWeekReport || "生成报告" }}</el-button>
      </template>
    </avue-crud>

    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="45%">
      <el-input v-model="inputValue" placeholder="请输入家医助理" clearable></el-input>

      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="updatedoc2">确认修改</el-button>
      </template>
    </el-dialog>

    <el-dialog title="周报文本" :visible.sync="dialogVisible2" width="30%">
      <span v-for="(item, index) in text" :key="index">
        <span :style="{ color: index === 4 && text.length === 7 ? 'red' : '' }">
          {{ item }}
          <br />
          <br />
        </span>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copy()">复 制</el-button>
        <!-- <el-button @click="dialogVisible2 = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="请选择管理师" :visible.sync="showHealthManager" width="40%" center>
      <div style="text-align: center">
        <el-button style="font-size: 15px; margin: 5px" @click="alterManager(item, index)" v-for="(item, index) in healthManager" :key="index" :type="item.isMy === 1 ? 'primary' : ''">
          {{ item.manager.userName }}
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="消息推送" :visible.sync="showPushMessage" width="30%">
      <el-input type="textarea" :rows="6" placeholder="请输入推送内容" v-model="pushMessage"></el-input>
      <div class="pushModel">
        <div>推送模板:</div>
        <el-button @click="pushModel(0)">推送文案</el-button>
      </div>
      <div class="deviceList">
        <div>选择设备:</div>
        <el-radio v-for="(item, index) in deviceList" :key="item.imei" v-model="deviceIndex" :label="index">
          {{ item.deviceName + "(" + item.imei + ")" }}
        </el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPushMessage = false">取 消</el-button>
        <el-button type="primary" @click="push">确 定 推 送</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新建报告解读用户" :visible.sync="showReportUser" width="20%">
      <div class="infoModel">
        <div>姓名：</div>
        <div>
          <el-input v-model="reportUserName" placeholder="请输入内容"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showReportUser = false">取 消</el-button>
        <el-button type="primary" @click="createReportUser">创 建</el-button>
      </span>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from "vuex";
import { onlineManage, updatedoc2, getWeekReport, updateChatDate, getHealthManager, alterManager, getAiWeekReportStateByUser, addAiWeekReportByUserReport, addAiWeekReportByUser, pushMessage, getDeviceToPush, createReportUser } from "@/api/health/manage";
import func from "@/util/func";

export default {
  data() {
    return {
      text: "",
      dialogVisible2: false,
      channel: window.localStorage.getItem("channel"),
      params: {
        channel: window.localStorage.getItem("channel"),
        pcUserId: window.localStorage.getItem("pcUserId"),
      },
      inputValue: "",
      updId: "",
      dialogVisible: false,
      dialogTitle: "修改家医助理",
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      // headerCellClassName: 'headerClass',
      option: {
        indexLabel: "序号",
        tip: false,
        border: false,
        index: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menuWidth: 150, // 初始宽度
        // selection: true,
        searchSpan: 4,
        searchEnter: true,
        searchMenuSpan: 4,
        column: [
          {
            label: "用户姓名",
            prop: "name",
            search: true,
            searchValue: "",
            width: 110,
          },
          {
            label: "联系方式",
            prop: "mobile",
            search: true,
            width: 110,
          },
          {
            label: "VIP等级",
            prop: "level",
            search: true,
            type: "select",
            dicData: [
              { label: "注册用户", value: 0 },
              // { label: "基础会员", value: 1 },
              { label: "体验会员", value: 2 },
              { label: "月度会员", value: 4 },
              { label: "季度会员", value: 5 },
              { label: "全年会员", value: 3 },
              { label: "vip会员", value: 6 },
              { label: "报告解读", value: 999 },
            ],
          },
          {
            label: "会员到期时间",
            prop: "end",
            width: 150,
          },
          {
            label: "渠道",
            prop: "channel",
            width: 150,
          },
          // {
          //   label: ' 家医助理',
          //   prop: 'doc2',
          //   search: true
          // },
          {
            label: "健康动态数据",
            prop: "menu1",
            // search: true,
            width: 120,
          },
          {
            label: "数字档案完成度",
            prop: "menu2",
            width: 120,
          },
          {
            label: "健康管理方案",
            prop: "menu3",
            width: 120,
          },
          {
            label: "认知行为治疗状态",
            prop: "menu4",
            width: 140,
          },
          {
            label: "消息推送",
            prop: "push",
            search: true,
            type: "select",
            dicData: [
              { label: "未开通", value: "0" },
              { label: "已开通", value: "1" },
            ],
          },
          {
            label: "免打扰",
            prop: "dis",
            // search: true,
            dicData: [
              { label: "未开启", value: "0" },
              { label: "已开启", value: "1" },
            ],
          },
          // {
          //   label: "线上家医咨询状态",
          //   prop: "",
          //   // search: true,
          //   dicData: [
          //     { label: "无咨询", value: 0 },
          //     { label: "新咨询", value: 1 },
          //     { label: "咨询中", value: 2 },
          //     { label: "咨询结束", value: 3 },
          //   ],
          // },
          {
            label: "AI助理咨询剩余时间",
            prop: "time",
            formatter: (row) => {
              return row.time ? `${Math.floor(row.time / 60)}分钟` : "";
            },
          },
          {
            label: "AI咨询轮次",
            prop: "num",
            formatter: (row) => {
              return row.num ? `${row.num}次` : "";
            },
          },
          {
            label: "健康咨询",
            prop: "consult",
          },
          {
            label: "AI全科会诊",
            prop: "AIConsult",
          },
          {
            label: "健康管理师",
            prop: "healthManager",
            overHidden: true,
          },
          {
            label: "健康快照解读",
            prop: "aiWeekReport",
            width: 150,
          },
          // {
          //   label: '体检报告用户AI周报生成',
          //   prop: 'aiWeekReportByReport',
          //   width: 180
          // }
          {
            label: "生成时间",
            prop: "pdfDate",
            width: 160,
          },
        ],
      },
      option2: {
        indexLabel: "序号",
        tip: false,
        border: false,
        index: true,
        menu: true,
        viewBtn: false,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menuWidth: 150, // 初始宽度
        // selection: true,
        searchSpan: 4,
        searchEnter: true,
        searchMenuSpan: 4,
        column: [
          {
            label: "用户姓名",
            prop: "name",
            search: true,
            searchValue: "",
            width: 110,
          },
          {
            label: "联系方式",
            prop: "mobile",
            search: true,
            width: 110,
          },
          {
            label: "VIP等级",
            prop: "level",
            search: true,
            type: "select",
            dicData: [
              { label: "注册用户", value: 0 },
              // { label: "基础会员", value: 1 },
              { label: "体验会员", value: 2 },
              { label: "月度会员", value: 4 },
              { label: "季度会员", value: 5 },
              { label: "全年会员", value: 3 },
              { label: "vip会员", value: 6 },
              { label: "报告解读", value: 999 },
            ],
          },
          {
            label: "会员到期时间",
            prop: "end",
            width: 150,
          },
          // {
          //   label: ' 家医助理',
          //   prop: 'doc2',
          //   search: true
          // },
          {
            label: "健康动态数据",
            prop: "menu1",
            // search: true,
            width: 120,
          },
          {
            label: "数字档案完成度",
            prop: "menu2",
            width: 120,
          },
          {
            label: "健康管理方案",
            prop: "menu3",
            width: 120,
          },
          {
            label: "认知行为治疗状态",
            prop: "menu4",
            width: 140,
          },
          {
            label: "消息推送",
            prop: "push",
            search: true,
            type: "select",
            dicData: [
              { label: "未开通", value: "0" },
              { label: "已开通", value: "1" },
            ],
          },
          {
            label: "免打扰",
            prop: "dis",
            // search: true,
            dicData: [
              { label: "未开启", value: "0" },
              { label: "已开启", value: "1" },
            ],
          },
          // {
          //   label: "线上家医咨询状态",
          //   prop: "",
          //   // search: true,
          //   dicData: [
          //     { label: "无咨询", value: 0 },
          //     { label: "新咨询", value: 1 },
          //     { label: "咨询中", value: 2 },
          //     { label: "咨询结束", value: 3 },
          //   ],
          // },
          {
            label: "AI助理咨询剩余时间",
            prop: "time",
            formatter: (row) => {
              return row.time ? `${Math.floor(row.time / 60)}分钟` : "";
            },
          },
          {
            label: "AI咨询轮次",
            prop: "num",
            formatter: (row) => {
              return row.num ? `${row.num}次` : "";
            },
          },
          {
            label: "健康咨询",
            prop: "consult",
          },
          {
            label: "健康管理师",
            prop: "healthManager",
            overHidden: true,
          },
        ],
      },
      data: [],
      notData: 0,
      notWeekReport: 0,
      notBehavioralIntervention: 0,
      notHealthScheme: 0,
      notHealthReportAndQuestion: 0,
      showHealthManager: false,
      healthManager: [],
      alterWxUserId: "",

      allAndManage: 1, // 1-健管师 0-所有用户
      showPushMessage: false,
      pushMessage: "",
      device: [],
      deviceIndex: 0,
      reportUserInfo: {},
      showReportUser: false,
      reportUserName: "",
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },

  beforeRouteLeave(to, from, next) {
    const state = {
      params: { ...this.params },
      page: { ...this.page },
    };
    sessionStorage.setItem("onlineManager", JSON.stringify(state));
    next();
  },

  methods: {
    onLoad(page, params) {
      const savedState = sessionStorage.getItem("onlineManager");
      if (savedState) {
        const state = JSON.parse(savedState);
        page = state.page;
        params = state.params;
        this.page = state.page;
        this.params = state.params;
        this.notData = state.params.notData;
        this.notWeekReport = state.params.notWeekReport;
        this.notBehavioralIntervention = state.params.notBehavioralIntervention;
        this.notHealthScheme = state.params.notHealthScheme;
        this.notHealthReportAndQuestion = state.params.notHealthReportAndQuestion;
        this.option.column[0].searchValue = params.name;
        this.option.column[1].searchValue = params.mobile;
        this.option.column[2].searchValue = params.vipLevel;
        this.option.column[4].searchValue = params.doc2;
        this.option.column[9].searchValue = params.push;
        sessionStorage.removeItem("onlineManager");
      }

      params.notData = this.notData;
      params.notWeekReport = this.notWeekReport;
      params.notBehavioralIntervention = this.notBehavioralIntervention;
      params.notHealthScheme = this.notHealthScheme;
      params.notHealthReportAndQuestion = this.notHealthReportAndQuestion;
      params.channel = window.localStorage.getItem("channel");
      params.pcUserId = window.localStorage.getItem("pcUserId");

      // params.allAndManage = this.allAndManage // 筛选管理师

      onlineManage(page.currentPage, page.pageSize, params).then((res) => {
        const wxUserId = window.localStorage.getItem("pcUserId");
        if (wxUserId === "2043870969731301377" && res.data.online.length > 0) {
          res.data.online.forEach((item) => {
            item.mobile = func.maskPhone(item.mobile);
            item.name = func.maskName(item.name);
          });
        }
        this.page.total = res.data.total;
        this.data = res.data.online;

        console.log("onlineManage res", res);
      });
    },

    playOnce() {
      const audio = this.$refs.audioElement;
      audio.currentTime = 0; // 初始0秒
      audio.loop = false; // 不循环
      audio.play().catch((e) => {
        console.log("播放失败:", e);
        this.remind();
      });
    },

    push(done) {
      this.$confirm("确认推送？")
        .then((_) => {
          console.log(this.deviceList[this.deviceIndex].imei);
          pushMessage(this.deviceList[this.deviceIndex].imei, this.pushMessage, "大白提醒").then((res) => {
            if (res.success) this.$message.success("推送成功");
            this.showPushMessage = false;
          });
          done();
        })
        .catch((_) => {});
    },

    pushModel() {
      this.$message.error("功能未完善");
    },

    toPush(row, index) {
      getDeviceToPush(row.id).then((res) => {
        console.log(res.data);
        if (res.success && res.data.length > 0) {
          this.showPushMessage = true;
          this.pushMessage = "";
          this.deviceList = res.data;
          this.deviceIndex = 0;
        } else {
          this.$message.error("此功能为4G手表和复云手表功能, 用户没有绑定相应手表");
        }
      });
    },

    handleAllAndManageChange(newValue) {
      console.log("开关状态改变:", newValue);
      // this.loadData()
    },

    alterManager(item, index) {
      alterManager(item.isMy, item.manager.wxUserId, this.alterWxUserId).then((res) => {
        if (res.success) {
          if (this.healthManager[index].isMy === 0) {
            this.$message.success("新增成功");
            this.healthManager[index].isMy = 1;
          } else {
            this.$message.error("删除成功");
            this.healthManager[index].isMy = 0;
          }
          this.onLoad(this.page, this.params);
        }
      });
    },

    toShowHealthManager(row) {
      this.alterWxUserId = row.id;
      getHealthManager(row.id, this.channel).then((res) => {
        this.healthManager = res.data;
        this.showHealthManager = true;
      });
    },

    toHealthConsult(row) {
      console.log(row.healthManager);
      if (row.consult === 0 && row.healthManager === undefined) {
        this.$message.error("用户无健康咨询");
        return;
      }

      console.log("chatId", row.group_chat_id);

      const parameter = {
        chatId: row.group_chat_id,
        wxUserId: row.id,
      };
      updateChatDate(row.id);

      this.$router.push({
        path: "/healthmanagement/healthConsult",
        query: parameter,
      });
    },

    toAIHealthConsult(row) {
      console.log("test row", row);
      const parameter = {
        wxUserId: row.id,
      };
      this.$router.push({
        path: "/doctor/AIManage",
        query: parameter,
      });
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem("channel"),
        pcUserId: window.localStorage.getItem("pcUserId"),
      };
      // params.allAndManage = this.allAndManage // 筛选管理师
      this.page.currentPage = 1;
      this.onLoad(this.page, this.params);
    },

    searchChange(params, done) {
      params.notData = this.params.notData;
      params.notWeekReport = this.params.notWeekReport;
      params.notBehavioralIntervention = this.params.notBehavioralIntervention;
      params.notHealthScheme = this.params.notHealthScheme;
      params.notHealthReportAndQuestion = this.params.notHealthReportAndQuestion;
      params.channel = window.localStorage.getItem("channel");
      params.pcUserId = window.localStorage.getItem("pcUserId");
      // params.allAndManage = this.allAndManage // 筛选管理师

      this.params = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },

    notDataClick(index) {
      switch (index) {
        case 1:
          if (this.notData === 1) this.notData = 0;
          else this.notData = 1;
          break;
        case 2:
          if (this.notWeekReport === 1) this.notWeekReport = 0;
          else this.notWeekReport = 1;
          break;
        case 3:
          if (this.notBehavioralIntervention === 1) {
            this.notBehavioralIntervention = 0;
          } else this.notBehavioralIntervention = 1;
          break;
        case 4:
          if (this.notHealthScheme === 1) this.notHealthScheme = 0;
          else this.notHealthScheme = 1;
          break;
        case 5:
          if (this.notHealthReportAndQuestion === 1) {
            this.notHealthReportAndQuestion = 0;
          } else this.notHealthReportAndQuestion = 1;
          break;
      }

      this.page.currentPage = 1;
      this.onLoad(this.page, this.params);
    },

    toCopy(row, index) {
      const wxUserId = row.wxUserId;
      this.reportTitle = row.name + "的周报";
      getWeekReport(wxUserId).then((res) => {
        if (res.success) {
          this.text = res.data.split("<br/>");
          this.copy();
        } else {
          this.$message({
            message: "复制失败",
            type: "error",
          });
        }
      });
    },

    weekReport(row, index) {
      const wxUserId = row.wxUserId;
      this.reportTitle = row.name + "的周报";
      getWeekReport(wxUserId).then((res) => {
        if (res.success) {
          this.text = res.data.split("<br/>");
        }
      });

      this.dialogVisible2 = true;
    },

    copy() {
      this.dialogVisible2 = false;

      let copyText = "";
      this.text.forEach((item) => {
        copyText += item + "\n";
      });

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(copyText)
          .then(() => {
            this.$message({
              message: "复制成功",
              type: "success",
            });
          })
          .catch((err) => {
            console.error("复制失败:", err);
            this.$message({
              message: "复制失败",
              type: "error",
            });
          });
      } else {
        this.fallbackCopyText();
      }
    },

    archiveType1(row) {
      // console.log("test row", row)
      const parameter = {
        wxUserId: row.id,
      };

      this.$router.push({
        path: "/healthmanagement/healthdata",
        query: parameter,
      });
    },

    archiveType2(row) {
      const parameter = {
        wxUserId: row.id,
      };
      this.$router.push({
        path: "/healthmanagement/digitalarchives",
        query: parameter,
      });
    },

    archiveType3(row) {
      const parameter = {
        wxUserId: row.id,
      };
      this.$router.push({
        path: "/healthmanagement/healthplan",
        query: parameter,
      });

      // const routeData = this.$router.resolve({
      //   path: "/healthmanagement/healthplan",
      //   query: parameter,
      // });
      // window.open(routeData.href, "_blank");
    },

    archiveType4(row) {
      const parameter = {
        wxUserId: row.id,
      };
      this.$router.push({
        path: "/healthmanagement/cognitivebehavioral",
        query: parameter,
      });

      // const routeData = this.$router.resolve({
      //   path: "/healthmanagement/cognitivebehavioral",
      //   query: parameter,
      // });
      // window.open(routeData.href, "_blank");
    },

    archiveType5(row) {
      const parameter = {
        wxUserId: row.id,
      };
      this.$router.push({
        path: "/healthmanagement/pushmessages",
        query: parameter,
      });

      // const routeData = this.$router.resolve({
      //   path: "/healthmanagement/pushmessages",
      //   query: parameter,
      // });
      // window.open(routeData.href, "_blank");
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    handleCellClick(row, column, cell, event) {
      const key = column.columnKey;
      if (key === "doc2") {
        this.dialogVisible = true;
        this.inputValue = row.doc2;
        this.updId = row.id;
      }
    },

    updatedoc2() {
      if (this.inputValue === "") {
        this.inputValue = " ";
      }
      updatedoc2(this.updId, this.inputValue).then((res) => {
        this.dialogVisible = false;
        if (res.success) {
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        }
      });
    },

    toGenerateAiWeekReportByUser(row, done) {
      const wxUserId = row.id;
      const level = row.level;
      const t = this;

      this.$confirm("确认生成？")
        .then((_) => {
          if (level !== 999) {
            console.log("会员用户");
            getAiWeekReportStateByUser(wxUserId).then((res) => {
              const state = res.data.state;
              if (state === 0) {
                addAiWeekReportByUser(wxUserId).then((res) => {
                  window.alert("AI周报生成中！");
                });
              } else if (state === 1) {
                window.alert("AI周报生成中，请勿重复点击！");
              } else {
                this.$confirm("AI周报已生成，是否要重新生成？")
                  .then((_) => {
                    console.log("ceshishengcheng");
                    addAiWeekReportByUser(wxUserId).then((res) => {
                      window.alert("AI周报生成中！");
                      t.onLoad(t.page, t.params);
                    });
                    done();
                  })
                  .catch((_) => {});
                // window.alert('AI周报已生成，请勿重复点击！')
              }
            });
          } else {
            console.log("报告解读");
            getAiWeekReportStateByUser(wxUserId).then((res) => {
              const state = res.data.state;
              if (state === 0) {
                addAiWeekReportByUserReport(wxUserId).then((res) => {
                  window.alert("AI周报生成中！");
                  t.onLoad(t.page, t.params);
                });
              } else if (state === 1) {
                window.alert("AI周报生成中，请勿重复点击！");
              } else {
                this.$confirm("AI周报已生成，是否要重新生成？")
                  .then((_) => {
                    console.log("ceshishengcheng");
                    addAiWeekReportByUserReport(wxUserId).then((res) => {
                      window.alert("AI周报生成中！");
                    });
                    done();
                  })
                  .catch((_) => {});
                // window.alert('AI周报已生成，请勿重复点击！')
              }
            });
          }
          done();
        })
        .catch((_) => {});
    },

    toGenerateAiWeekReportByUserReport(row) {
      const wxUserId = row.id;
      console.log(row);
      console.log(row.level);
      console.log(row);
      getAiWeekReportStateByUser(wxUserId).then((res) => {
        const state = res.data.state;
        if (state === 0) {
          addAiWeekReportByUserReport(wxUserId).then((res) => {
            window.alert("AI周报生成中！");
          });
        } else if (state === 1) {
          window.alert("AI周报生成中，请勿重复点击！");
        } else {
          window.alert("AI周报已生成，请勿重复点击！");
        }
      });
    },

    toCreateReportUser() {
      this.showReportUser = true;
    },

    createReportUser() {
      console.log(this.reportUserName);
      // createReportUser
      const param = {
        name: this.reportUserName,
      };
      createReportUser(param).then((res) => {
        if (res.success) {
          this.showReportUser = false;
          this.onLoad(this.page, this.params);
          this.$message.success("新建成功!");
        }
      });
    },
  },
};
</script>
<style scoped>
.headerClass {
  background-color: #409eff !important;
  color: #fff !important;
}

.pushModel {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.deviceList {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.infoModel {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
